import { render, staticRenderFns } from "./RecordForm.vue?vue&type=template&id=59e5db32&scoped=true"
import script from "./RecordForm.vue?vue&type=script&lang=js"
export * from "./RecordForm.vue?vue&type=script&lang=js"
import style0 from "./RecordForm.vue?vue&type=style&index=0&id=59e5db32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e5db32",
  null
  
)

export default component.exports